// Bootstrap plugins (Collapse, Dropdown, Modal): importing them registers the
// data-api handlers the templates rely on. Exposed globally for inline scripts.
import * as bootstrap from "./bootstrap.js";

window.bootstrap = bootstrap;

(function () {
	"use strict";

	//mobile menu
	const mobileSubMenuItems = document.querySelectorAll('.navbar .nav-item.has-children > .nav-link');
	mobileSubMenuItems.forEach(link => {
		link.addEventListener('click', function (event) {


			if (window.innerWidth < 992) {
				event.preventDefault();

				// clone link element
				const linkClone = link.cloneNode(true);

				link.closest('.has-children').querySelector('.submenu-title').replaceChildren(linkClone);

				//show submenu
				link.closest('.has-children').classList.add("active");
			}

		});
	});

	const mobileSubMenuBack = document.querySelectorAll('.navbar .nav-item.has-children a.go-back');
	mobileSubMenuBack.forEach(link => {
		link.addEventListener('click', function (event) {
			event.preventDefault();

			//go to parent menu
			link.closest('.has-children').classList.remove("active");
		});
	});

	const stickyNav = document.querySelector("js-navbar");
	if (stickyNav !== null) {
		const stickyNavTop = 110;

		const stickyNavCal = function () {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (scrollTop >= stickyNavTop) {
				stickyNav.classList.add("sticky");
			} else {
				stickyNav.classList.remove("sticky");
			}
		};

		window.addEventListener("scroll", stickyNavCal);

		stickyNavCal();
	}

	const heroSwipers = document.querySelectorAll('.hero-slider .swiper');
	if (heroSwipers.length > 0) {
		heroSwipers.forEach(function (slider) {
			const swiper_id = slider.getAttribute('id');
			const numSlides = slider.querySelectorAll('.swiper-slide').length;
			const heroSwiper = new Swiper('#' + swiper_id, {
				loop: numSlides > 1,
				watchOverflow: true,

				speed: 600,
				autoplay: {
					delay: 3000,
					disableOnInteraction: true,
					pauseOnMouseEnter: true,
				}
			});
		});
	}

	const productCarouselSwipers = document.querySelectorAll('.product-carousel .swiper');
	if (productCarouselSwipers.length > 0) {
		productCarouselSwipers.forEach(function (slider) {
			const swiper_id = slider.getAttribute('id');
			const autoplaySet = slider.getAttribute('data-autoplay');
			const numSlides = slider.querySelectorAll('.swiper-slide').length;
			var autoplayOption = false;
			if (autoplaySet) {
				autoplayOption = {
					delay: 2000,
					disableOnInteraction: true,
					pauseOnMouseEnter: true,
				}
			}
			const productCarouselSwiper = new Swiper('#' + swiper_id, {
				speed: 400,
				loop: numSlides > 1,
				watchOverflow: true,
				autoHeight: true,
				autoplay: autoplayOption,

				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			});
		});
	}

	const productSwipers = document.querySelectorAll('.product-slider .swiper');
	if (productSwipers.length > 0) {
		productSwipers.forEach(function (slider) {
			const swiper_id = slider.getAttribute('id');
			const numSlides = slider.querySelectorAll('.swiper-slide').length;
			const productSwiper = new Swiper('#' + swiper_id, {
				speed: 400,
				loop: numSlides > 1,
				watchOverflow: true,

				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					clickable: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			});
		});
	}


	const productTableSwipers = document.querySelectorAll('.product-table-slider .swiper');
	if (productTableSwipers.length > 0) {
		productTableSwipers.forEach(function (slider) {
			const swiper_id = slider.getAttribute('id');
			const productTableSwiper = new Swiper('#' + swiper_id, {
				speed: 400,
				loop: true,

				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			});

			productTableSwiper.on('slideChange', function () {
				var activeSlide = productTableSwiper.slides[productTableSwiper.activeIndex];
				var title = activeSlide.dataset.title;
				document.getElementById('js-swiper-slide-title').innerHTML = title;
			});

		});
	}

	if (document.querySelectorAll('.js-anchor-menu-wrapper').length > 0) {
		const navbarAnchor = document.querySelector('.js-anchor-menu');
		const navbarAnchorWrapper = document.querySelector('.js-anchor-menu-wrapper');
		
		// Add null checks for required elements
		const navbar = document.querySelector('.js-navbar');
		const pageHeader = document.querySelector('.page-header');
		const jsCol = document.querySelector('.js-col');
		
		// Only proceed if all required elements exist
		if (navbar && pageHeader && jsCol && navbarAnchor && navbarAnchorWrapper) {
			const navbarOffset = navbar.offsetHeight + pageHeader.offsetHeight - 30;
			const stickyWidth = jsCol.offsetWidth - 32; //minus padding

			// Check if we're dealing with an article menu
			const articleMenu = document.querySelector('.block-article-with-menu');
			const jobsMenu = document.querySelector('.block-jobs-with-menu');
			
			if (articleMenu) {
				// Article menu logic - populate menu + sticky behavior
				const anchorArray = {};
				let i = 1;
				const stickyNavAnchorTop = navbarAnchor.offsetTop;
				const containerDiv =
					articleMenu.offsetTop +
					articleMenu.offsetHeight;

				// Only populate menu for article content blocks
				articleMenu.querySelectorAll('.block-article-content').forEach((content) => {
					const attr = content.getAttribute('data-anchor');
					if (typeof attr !== typeof undefined && attr !== false) {
						anchorArray[i] = {
							id: content.getAttribute('id'),
							title: content.getAttribute('data-title'),
						};
						i++;
					}
				});

				// Only add menu items if we found article content
				if (Object.keys(anchorArray).length > 0) {
					Object.values(anchorArray).forEach((anchor) => {
						navbarAnchor.innerHTML += `<li><a class="anchor-menu-item" href="#${anchor.id}">${anchor.title}</a></li>`;
					});
				}
			}

			// Sticky behavior for ALL menus (article and jobs)
			const stickyAnchorNav = () => {
				const navbarAnchorParent = navbarAnchorWrapper.parentElement;
				const scrollNavBottom = window.pageYOffset + navbarAnchorParent.offsetHeight;
				
				// Use the appropriate container div based on menu type
				let containerDiv;
				if (articleMenu) {
					containerDiv = articleMenu.offsetTop + articleMenu.offsetHeight;
				} else if (jobsMenu) {
					containerDiv = jobsMenu.offsetTop + jobsMenu.offsetHeight;
				}
				
				const containerBottom = containerDiv + navbarOffset - 120;

				if (window.pageYOffset > navbarOffset) {
					if (window.innerWidth > 992) {
						navbarAnchorParent.style.width = `${stickyWidth}px`;
						navbarAnchorParent.classList.add('sticky');
						navbarAnchorParent.classList.remove('sticky-no-top');

						//menu on bottom of div
						if (scrollNavBottom > containerBottom) {
							navbarAnchorParent.classList.remove('sticky');
							navbarAnchorParent.classList.add('sticky-no-top');
						}
					}
				} else {
					navbarAnchorParent.classList.remove('sticky');
					navbarAnchorParent.classList.remove('sticky-no-top');
				}
			};
			
			stickyAnchorNav();

			window.addEventListener('scroll', () => {
				stickyAnchorNav();
			});

			window.addEventListener('resize', () => {
				stickyAnchorNav();
			});
		}
	}

	//scroll animation anchor link
	const scrollLinks = document.querySelectorAll('a[href^="#"]');
	scrollLinks.forEach(link => {
		link.addEventListener('click', function (event) {
			event.preventDefault();

			//skip faq links
			const attr = link.getAttribute('data-bs-toggle');
			if (attr !== 'collapse') {
				const targetId = link.getAttribute('href').substr(1);
				const target = document.getElementById(targetId);

				if (target) {
					const headerHeight = document.querySelector('.js-navbar').offsetHeight;
					const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

					window.scrollTo({
						top: targetPosition,
						behavior: 'smooth'
					});

				};
			}
		});
	});


	// on click on a with btn-cta class change href with extra parameter
	const ctaLinks = document.querySelectorAll('.btn-cta');
	ctaLinks.forEach(link => {
		link.addEventListener('click', function (event) {
			let color = getColorSlideIndex();
			let href = link.getAttribute('href');
			link.setAttribute('href', href + '-' + color);
		});
	});

	var videomodalLinks = document.querySelectorAll('a.videomodal');
	for (var i = 0; i < videomodalLinks.length; i++) {
		videomodalLinks[i].addEventListener('click', function (e) {
			e.preventDefault();
			var src = this.dataset.video;

			document.querySelector('#videoModal iframe').setAttribute('src', src);
			document.querySelector('#videoModal').classList.add('show');
		});
	}

	//stop video on modal close
	var videomodalClose = document.querySelector('#videoModal .btn-close');
	if (videomodalClose) {
		videomodalClose.addEventListener('click', function (e) {
			e.preventDefault();
			document.querySelector('#videoModal iframe').setAttribute('src', '');
		});
	}


	//fake search click
	if (document.querySelector('.js-wpsl-submit-text') != null) {
		document.querySelector('.js-wpsl-submit-text').addEventListener('click', function (e) {
			const parentSelector = e.target.closest('.wpsl-search-btn-wrap');
			const submitInput = parentSelector.querySelector('.wpsl-search-btn input[type="submit"]');
			submitInput.click();
		});
	}

	// add aria-describedby to button with target _blank
	const buttons = document.querySelectorAll('a[target="_blank"]');
	buttons.forEach(button => {
		button.setAttribute('aria-describedby', 'Opent in nieuw tabblad');
	});

	// add aria-describedby to button without target _blank
	const buttonsNoBlank = document.querySelectorAll('a:not([target="_blank"])');
	buttonsNoBlank.forEach(button => {
		button.setAttribute('aria-describedby', 'U gaat naar een andere pagina');
	});

	// Check if the URL contains 'utm_source=audibene'
	if (window.location.search.includes('utm_source=audibene')) {
		// Select the gform_heading div and add the 'show-audibene' class
		const gformHeading = document.querySelector('.gform_wrapper');
		if (gformHeading) {
			gformHeading.classList.add('show-audibene-logo');
		}
	}

})();
